<div class="header">
  <ion-icon name="checkmark-outline" (click)="confirm()" class="header-button"></ion-icon>
  <ion-icon name="close-outline" (click)="cancel()" class="header-button"></ion-icon>
</div>

<div class="content">

  <div class="title">
    Cursos
  </div>

  
  <ion-grid class="global-filter-area">
    <ion-row>
      <ion-col sizeXs="12" sizeSm="12" sizeMd="6" sizeLg="6" sizeXl="6">

        <ion-item>
          <ion-label position="floating">Nome do Curso</ion-label>
          <ion-input placeholder="Filtro"[(ngModel)]="filtro" (ionChange)="filter()"></ion-input>
        </ion-item>

      </ion-col>

      <ion-col sizeXs="12" sizeSm="12" sizeMd="6" sizeLg="6" sizeXl="6">

        <ion-item>
          <ion-label position="floating">Formação</ion-label>
          <ion-select [(ngModel)]="formacao" (ionChange)="filter()" cancelText="Cancelar">
            <ion-select-option [value]="">Todos</ion-select-option>
            <ion-select-option *ngFor="let formacao of formacoes" [value]="formacao">{{formacao.nome}}</ion-select-option>
          </ion-select>
        </ion-item>

      </ion-col>
    </ion-row>
  </ion-grid>
  
  <ion-item>
    <ion-button slot="end" (click)="selectAll()"  >Marcar todos</ion-button>
    <ion-button slot="end" (click)="cursosSelecionados=[];"  >Desmarcar todos</ion-button>
  </ion-item>

  

  <ion-item *ngFor="let  curso of cursosFiltrados">
  
    <ion-checkbox [checked]="checked(curso)" 
                  (ionChange)="addCurso($event, curso)"></ion-checkbox>
    <div *ngIf="curso.habilitacao">&nbsp;{{curso.nome}} - {{curso.habilitacao?.nome}} ({{curso.modalidade?.nome}})</div>
    <div *ngIf="!curso.habilitacao">&nbsp;{{curso.nome}} ({{curso.modalidade?.nome}})</div>
    
  </ion-item>

  <div class="flex-box" style="margin-top: 50px;">
    <div>
      <ion-button class="cancel-button" (click)="cancel()">Cancelar</ion-button>
    </div>
    <div>
      <ion-button class="cancel-button" (click)="confirm()">Confirmar</ion-button>
    </div>
  </div>
  
</div>
